module.exports = __webpack_public_path__ + "static/img/katun08.002dd7f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/blog/katun08.jpg
// module id = y5ko
// module chunks = 0